import React, {FC, useState} from "react";
import {LearnCategory} from "../../../../lib/src/api/repositories/learn-repository";
import {Select} from "../../../../lib/src/components/form/Select";
import {useApiCall} from "../../../../lib/src/api";
import {config} from "../../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const BulkMoveToCategoryModal: FC<{ selected: string[], categories: LearnCategory[], reload: () => void }> = (props) => {
  const {learn} = useApiCall(config)
  const [selectedCategory, setSelectedCategory] = useState<string>(props.categories[0].id);
  const categoryMap = [
    ['-', 'Selecteer een categorie om naar te verplaatsen'],
    ['geen', 'Verplaats naar hoofdcategorie'],
    ...props.categories.filter(c => !props.selected.includes(c.id)).map(category => [category.id, category.name])
  ];
  const save = async () => {
    const promises = props.selected.map(async (category) => {
      await learn.moveCategory(
        category,
        selectedCategory,
      )
    })
    await Promise.all(promises)
    props.reload()
  }

  return <>
    <Select label={'Verplaats naar categorie'} options={Object.fromEntries(categoryMap)} value={selectedCategory}
            onChange={(c) => setSelectedCategory(c)} />
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </>
}